// 「⬇ 下載 PDF」— 文件檢視畫面的輸出入口 (2026-09-02 使用者:「其他系統上面的
// 列印 都可以改用這邊的功能 讓我可以直接下載 pdf 嗎?」)。
// 實作在 lib/dom-pdf.ts (html2canvas + jsPDF, 按下才動態載 ~500KB — 同 Invoice)。
//
// 2026-09-02 使用者:「有下載就不要有列印了」→ 原本並排的 🖨 列印按鈕全部移除,
// 這顆成為唯一的輸出動作 (所以預設樣式是主要按鈕)。 列印 CSS 保留 —— 使用者
// 仍可以自己 Ctrl+P, 那時版面才不會跑掉。
import { useState } from 'react';
import type { DomPdfOptions } from '../lib/dom-pdf.ts';
import { toastError } from '../lib/toast.ts';

export function DownloadPdfButton({
  targetSelector,
  fileName,
  orientation,
  extraCss,
  breakAfterSelector,
  className,
}: {
  /** 要輸出的文件根節點 (如 '.payslip-doc') — 按下當下 querySelector。 */
  targetSelector: string;
  /** 檔名 (可省略 .pdf); 傳函式 = 按下當下才算 (避免存到過期的年月)。 */
  fileName: string | (() => string);
  orientation?: DomPdfOptions['orientation'];
  extraCss?: string;
  breakAfterSelector?: string;
  className?: string;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      disabled={busy}
      onClick={async () => {
        const el = document.querySelector<HTMLElement>(targetSelector);
        if (!el) {
          toastError('找不到要輸出的文件內容。');
          return;
        }
        setBusy(true);
        try {
          const { downloadElementAsPdf } = await import('../lib/dom-pdf.ts');
          await downloadElementAsPdf(el, {
            fileName: typeof fileName === 'function' ? fileName() : fileName,
            orientation,
            extraCss,
            breakAfterSelector,
          });
        } catch (e) {
          toastError(e instanceof Error ? e.message : '產生 PDF 失敗');
        } finally {
          setBusy(false);
        }
      }}
      title="下載這份文件的 PDF 檔"
      className={
        className ??
        'px-4 py-2 text-sm bg-slate-900 text-white rounded hover:bg-slate-800 disabled:opacity-50'
      }
    >
      {busy ? '產生中…' : '⬇ 下載 PDF'}
    </button>
  );
}
